/**
 * System porównywania produktów – localStorage, pobieranie danych, tabela porównawcza.
 */
(function () {
  const STORAGE_KEY = 'wings_compare';
  const MAX_PRODUCTS = 4;
  const t = (key) => (typeof window.wingsCompareTranslations !== 'undefined' && window.wingsCompareTranslations[key]) || '';

  function getRootUrl() {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    const base = (typeof window.shopUrl !== 'undefined' ? window.shopUrl : window.location.origin) || '';
    return base ? base.replace(/\/?$/, '/') : '/';
  }

  function getCompareList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const list = JSON.parse(raw);
      return Array.isArray(list) ? list.slice(0, MAX_PRODUCTS) : [];
    } catch (_) {
      return [];
    }
  }

  function setCompareList(handles) {
    const list = handles.slice(0, MAX_PRODUCTS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    dispatchCompareUpdate();
  }

  function addToCompare(handle) {
    if (!handle || typeof handle !== 'string') return false;
    const list = getCompareList();
    const normalized = handle.trim().toLowerCase();
    if (list.some((h) => h.toLowerCase() === normalized)) return true;
    const next = [...list, handle.trim()].slice(-MAX_PRODUCTS);
    setCompareList(next);
    return true;
  }

  function removeFromCompare(handle) {
    const list = getCompareList().filter((h) => h.toLowerCase() !== String(handle).toLowerCase());
    setCompareList(list);
  }

  function dispatchCompareUpdate() {
    window.dispatchEvent(new CustomEvent('compare-updated', { detail: { list: getCompareList() } }));
  }

  function updateHeaderCount() {
    const countEl = document.querySelector('[data-compare-count]');
    if (!countEl) return;
    const list = getCompareList();
    const count = list.length;
    countEl.textContent = count;
    countEl.classList.toggle('hidden', count === 0);
    countEl.closest('.header__icon--compare')?.classList.toggle('has-count', count > 0);
  }

  function updateFloatingButton() {
    const floatBtn = document.querySelector('[data-compare-float]');
    if (!floatBtn) return;
    const list = getCompareList();
    const count = list.length;
    const countEl = floatBtn.querySelector('[data-compare-float-count]');
    if (countEl) {
      countEl.textContent = count;
      countEl.classList.toggle('hidden', count === 0);
    }
    floatBtn.classList.toggle('is-visible', count > 0);
  }

  function fetchProduct(handle) {
    const root = getRootUrl().replace(/\/?$/, '');
    const sectionUrl = `${root}/products/${encodeURIComponent(handle)}?section_id=product_compare_data`;
    return fetch(sectionUrl)
      .then((res) => {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const script = doc.querySelector('script[data-product-compare-json]');
        if (script && script.textContent) {
          try {
            return JSON.parse(script.textContent.trim());
          } catch (_) {}
        }
        throw new Error('No compare data');
      })
      .catch(() => {
        const url = `${root}/products/${encodeURIComponent(handle)}.js`;
        return fetch(url).then((res) => {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        }).then((data) => {
          if (data && data.variants && data.variants.length && !data.variant_id) {
            const v = data.variants.find((x) => x.available) || data.variants[0];
            data.variant_id = v && v.id;
          }
          return data;
        });
      });
  }

  // Prices come back from the Ajax API in the customer's presentment currency,
  // so they must be formatted in that currency too — see assets/wings-money.js.
  let moneyFormatter = null;
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '–';
    if (!moneyFormatter) {
      moneyFormatter = (window.WingsMoney && window.WingsMoney.formatterFor(document.getElementById('CompareDrawer')))
        || ((c) => ((Number(c) || 0) / 100).toFixed(2));
    }
    return moneyFormatter(cents);
  }

  function getFeaturedImageUrl(p) {
    const img = p && p.featured_image;
    if (!img) return '';
    return typeof img === 'string' ? img : (img.src || img.url || '');
  }

  function getMetafieldValue(product, namespace, key) {
    if (!product.metafields || !Array.isArray(product.metafields)) return null;
    const m = product.metafields.find((mf) => mf.namespace === namespace && mf.key === key);
    return m && m.value != null && m.value !== '' ? m.value : null;
  }

  function formatMetafieldValue(val) {
    if (val == null || val === '') return '–';
    if (typeof val === 'object') {
      if (val instanceof Array) return val.map((v) => formatMetafieldValue(v)).join(', ');
      if (val && typeof val.value !== 'undefined') return formatMetafieldValue(val.value);
      try {
        return escapeHtml(JSON.stringify(val));
      } catch (_) {
        return '–';
      }
    }
    return escapeHtml(String(val));
  }

  function buildCompareRows(products) {
    const fixedRows = [
      { key: 'image', label: t('table_image'), getVal: (p) => { const url = getFeaturedImageUrl(p); return url ? `<img src="${escapeHtml(url)}" alt="" class="compare-table__img" loading="lazy">` : '–'; } },
      { key: 'title', label: t('table_title'), getVal: (p) => escapeHtml(p.title || t('table_product_fallback') || '–') },
      { key: 'vendor', label: t('table_vendor'), getVal: (p) => escapeHtml(p.vendor || '–') },
      { key: 'type', label: t('table_type'), getVal: (p) => escapeHtml(p.type || '–') },
      { key: 'price', label: t('table_price'), getVal: (p) => formatMoney(p.price) },
      { key: 'price_promo', label: t('table_price_promo'), getVal: (p) => (p.compare_at_price && p.compare_at_price > p.price ? formatMoney(p.price) : '–') },
      { key: 'compare_at_price', label: t('table_compare_at_price'), getVal: (p) => (p.compare_at_price && p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : '–') },
      { key: 'price_regular', label: t('table_price_regular'), getVal: (p) => (p.compare_at_price && p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : formatMoney(p.price)) },
      { key: 'available', label: t('table_availability'), getVal: (p) => (p.available ? t('table_available_yes') : t('table_unavailable')) },
      { key: 'link', label: t('table_link'), getVal: (p) => { const url = p.url ? (p.url.startsWith('http') ? p.url : getRootUrl().replace(/\/?$/, '') + (p.url.startsWith('/') ? p.url : '/' + p.url)) : ''; return url ? `<a href="${escapeHtml(url)}" class="compare-table__link">${escapeHtml(t('table_view_product'))}</a>` : '–'; } },
      { key: 'atc', label: t('table_action'), getVal: (p) => {
        const vid = p.variant_id || (p.variants && p.variants[0] && p.variants[0].id);
        const available = p.available !== false;
        if (!vid) return '–';
        return available
          ? `<button type="button" class="compare-table__atc" data-compare-atc data-variant-id="${escapeHtml(String(vid))}">${escapeHtml(t('table_add_to_cart'))}</button>`
          : '<span class="compare-table__unavailable">' + escapeHtml(t('table_unavailable')) + '</span>';
      } },
    ];
    const metaKeys = new Map();
    products.forEach((p) => {
      if (p.metafields && Array.isArray(p.metafields)) {
        p.metafields.forEach((mf) => {
          if (mf.key && mf.value != null && mf.value !== '') {
            const id = (mf.namespace || '') + '.' + (mf.key || '');
            if (!metaKeys.has(id)) metaKeys.set(id, { namespace: mf.namespace || '', key: mf.key, label: (mf.namespace ? mf.namespace + ' / ' : '') + (mf.key || '').replace(/_/g, ' ') });
          }
        });
      }
    });
    const metaRows = Array.from(metaKeys.values()).map(({ namespace, key, label }) => ({
      key: 'meta.' + namespace + '.' + key,
      label: label,
      getVal: (p) => formatMetafieldValue(getMetafieldValue(p, namespace, key)),
    }));
    return fixedRows.concat(metaRows);
  }

  function escapeHtml(str) {
    if (str == null) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function renderCompareTable(products, container) {
    if (!container) return;
    if (!products.length) {
      container.innerHTML = '';
      return;
    }
    const rows = buildCompareRows(products);
    let tableHtml = '<table class="compare-table"><thead><tr><th class="compare-table__th compare-table__th--attr">' + escapeHtml(t('table_attribute')) + '</th>';
    products.forEach((p) => {
      const title = (p && p.title) ? escapeHtml(p.title) : (t('table_product_fallback') || '–');
      tableHtml += `<th class="compare-table__th">${title}</th>`;
    });
    tableHtml += '</tr></thead><tbody>';
    rows.forEach((row) => {
      tableHtml += '<tr>';
      tableHtml += `<td class="compare-table__td compare-table__td--attr">${row.label}</td>`;
      products.forEach((p) => {
        const val = row.getVal(p);
        tableHtml += `<td class="compare-table__td">${val}</td>`;
      });
      tableHtml += '</tr>';
    });
    tableHtml += '</tbody></table>';
    const showNav = products.length > 2;
    let navHtml = '';
    if (showNav) {
      navHtml = '<div class="compare-drawer__table-nav" data-compare-table-nav aria-hidden="false">' +
        '<button type="button" class="compare-drawer__table-nav-btn compare-drawer__table-nav-btn--prev" data-compare-scroll-prev aria-label="' + escapeHtml(t('scroll_prev_aria')) + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>' +
        '<button type="button" class="compare-drawer__table-nav-btn compare-drawer__table-nav-btn--next" data-compare-scroll-next aria-label="' + escapeHtml(t('scroll_next_aria')) + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg></button>' +
        '</div>';
    }
    container.innerHTML = navHtml + '<div class="compare-drawer__table-scroll"><div class="compare-drawer__table-inner">' + tableHtml + '</div></div>';
    if (showNav) initCompareTableNav(container);
  }

  function initCompareTableNav(container) {
    const scrollEl = container.querySelector('.compare-drawer__table-scroll');
    const prevBtn = container.querySelector('[data-compare-scroll-prev]');
    const nextBtn = container.querySelector('[data-compare-scroll-next]');
    if (!scrollEl || !prevBtn || !nextBtn) return;
    const step = 220;
    function updateButtons() {
      const scrollLeft = scrollEl.scrollLeft;
      const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
      prevBtn.classList.toggle('is-disabled', scrollLeft <= 0);
      nextBtn.classList.toggle('is-disabled', maxScroll <= 0 || scrollLeft >= maxScroll - 2);
    }
    prevBtn.addEventListener('click', () => {
      scrollEl.scrollBy({ left: -step, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      scrollEl.scrollBy({ left: step, behavior: 'smooth' });
    });
    scrollEl.addEventListener('scroll', updateButtons);
    updateButtons();
  }

  function openDrawer() {
    const drawer = document.querySelector('compare-drawer');
    if (!drawer) return;
    const list = getCompareList();
    const emptyEl = drawer.querySelector('[data-compare-empty]');
    const bodyEl = drawer.querySelector('[data-compare-body]');
    const tableEl = drawer.querySelector('[data-compare-table]');
    if (emptyEl) emptyEl.classList.toggle('hidden', list.length > 0);
    if (bodyEl) bodyEl.classList.toggle('hidden', list.length === 0);
    if (list.length === 0) {
      drawer.open();
      return;
    }
    const loadingEl = drawer.querySelector('[data-compare-loading]');
    if (loadingEl) loadingEl.classList.remove('hidden');
    if (tableEl) tableEl.innerHTML = '';
    Promise.all(list.map((handle) => fetchProduct(handle)))
      .then((results) => {
        const products = results.filter(Boolean);
        renderCompareTable(products, tableEl);
      })
      .catch(() => {
        if (tableEl) tableEl.innerHTML = '<p class="compare-drawer__error">' + escapeHtml(t('load_error')) + '</p>';
      })
      .finally(() => {
        if (loadingEl) loadingEl.classList.add('hidden');
      });
    drawer.open();
  }

  function initDrawer() {
    const drawer = document.querySelector('compare-drawer');
    if (!drawer) return;
    const closeBtn = drawer.querySelector('[data-compare-close]');
    const overlay = drawer.querySelector('[data-compare-overlay]');
    if (closeBtn) closeBtn.addEventListener('click', () => drawer.close());
    if (overlay) overlay.addEventListener('click', () => drawer.close());
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && drawer.classList.contains('active')) drawer.close();
    });
  }

  function isInCompare(handle) {
    if (!handle) return false;
    const list = getCompareList();
    const normalized = String(handle).trim().toLowerCase();
    return list.some((h) => h.toLowerCase() === normalized);
  }

  function updateCompareButtonStates() {
    const list = getCompareList();
    const normalizedList = list.map((h) => h.toLowerCase());
    document.querySelectorAll('[data-compare-add]').forEach((btn) => {
      const handle = btn.getAttribute('data-product-handle') || btn.getAttribute('data-compare-add');
      if (!handle) return;
      const inList = normalizedList.indexOf(handle.trim().toLowerCase()) !== -1;
      btn.classList.toggle('is-in-compare', inList);
    });
  }

  function initAddButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-compare-add]');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle') || btn.getAttribute('data-compare-add');
      if (!handle) return;
      if (isInCompare(handle)) {
        removeFromCompare(handle);
      } else {
        if (getCompareList().length >= MAX_PRODUCTS) {
          if (typeof alert !== 'undefined') alert(t('max_alert') || ('Możesz porównać maksymalnie ' + MAX_PRODUCTS + ' produkty. Usuń jeden z listy porównania.'));
          return;
        }
        addToCompare(handle);
      }
    });
  }

  function initFloatingButton() {
    const floatBtn = document.querySelector('[data-compare-float]');
    if (!floatBtn) return;
    floatBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  }

  function initHeaderTrigger() {
    const trigger = document.querySelector('[data-compare-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  }

  customElements.define(
    'compare-drawer',
    class CompareDrawer extends HTMLElement {
      open() {
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }
      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    }
  );

  function updateDrawerEmptyState() {
    const drawer = document.querySelector('compare-drawer');
    if (!drawer) return;
    const list = getCompareList();
    const emptyEl = drawer.querySelector('[data-compare-empty]');
    const bodyEl = drawer.querySelector('[data-compare-body]');
    if (emptyEl) emptyEl.classList.toggle('hidden', list.length > 0);
    if (bodyEl) bodyEl.classList.toggle('hidden', list.length === 0);
  }

  function initClearButton() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-compare-clear]')) return;
      setCompareList([]);
      updateDrawerEmptyState();
    });
  }

  function refreshCartDrawerContent() {
    const cart = document.querySelector('cart-drawer');
    if (!cart) return Promise.resolve();
    const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (var i = 0; i < selectors.length; i++) {
          var target = document.querySelector(selectors[i]);
          var source = doc.querySelector(selectors[i]);
          if (target && source) target.replaceWith(source);
        }
        var bubble = doc.querySelector('#cart-icon-bubble');
        var bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubble && bubbleTarget) bubbleTarget.innerHTML = bubble.innerHTML;
        var newCartDrawer = doc.querySelector('cart-drawer');
        if (cart && newCartDrawer && !newCartDrawer.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
          var emptyBlock = document.querySelector('.drawer__inner-empty.cart-drawer__empty');
          if (emptyBlock) emptyBlock.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  function initCompareAtc() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-compare-atc]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const cartAddUrl = (typeof window.routes !== 'undefined' && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sections = cart.getSectionsToRender().map((section) => section.id || section.section);
        formData.append('sections', Array.isArray(sections) ? sections.join(',') : sections);
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
      }
      const config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      btn.disabled = true;
      const origText = btn.textContent;
      btn.textContent = '…';
      fetch(cartAddUrl, config)
        .then((res) => res.json())
        .then((data) => {
          if (data && data.status) {
            btn.textContent = origText;
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'compare-drawer', message: data.description || data.message });
            }
            if (typeof alert !== 'undefined') alert(data.description || data.message || 'Nie udało się dodać do koszyka.');
            return;
          }
          btn.textContent = 'Dodano';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'compare-drawer', productVariantId: variantId, cartData: data });
          }
          var compareDrawer = document.querySelector('compare-drawer');
          refreshCartDrawerContent().then(function () {
            if (cart) {
              if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              if (typeof cart.open === 'function') cart.open();
            }
            if (compareDrawer && typeof compareDrawer.close === 'function') {
              setTimeout(function () { compareDrawer.close(); }, 60);
            }
          });
        })
        .catch(() => {
          btn.textContent = origText;
          if (typeof alert !== 'undefined') alert('Nie udało się dodać do koszyka.');
        })
        .finally(() => {
          btn.disabled = false;
          setTimeout(() => { btn.textContent = origText; }, 2000);
        });
    });
  }

  window.addEventListener('compare-updated', () => {
    updateHeaderCount();
    updateFloatingButton();
    updateCompareButtonStates();
    updateDrawerEmptyState();
  });
  window.addEventListener('DOMContentLoaded', () => {
    updateHeaderCount();
    updateFloatingButton();
    updateCompareButtonStates();
    initDrawer();
    initAddButtons();
    initFloatingButton();
    initHeaderTrigger();
    initClearButton();
    initCompareAtc();
  });

  window.CompareProducts = {
    getList: getCompareList,
    add: addToCompare,
    remove: removeFromCompare,
    openDrawer,
  };
})();